import { hubbleAPI } from './url'
const resource = hubbleAPI + 'public/contentful'
export default ($axios) => ({
  getFooter () {
    return $axios.get(`${resource}/footer`)
  },
  getHeader () {
    return $axios.get(`${resource}/header`)
  }
})
